"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const utils_1 = require("./utils");
const getTransactionStatus = (_account, tx) => __awaiter(void 0, void 0, void 0, function* () {
    const { commandDescriptor } = tx.model;
    if (commandDescriptor === undefined) {
        return {
            amount: tx.amount,
            estimatedFees: new bignumber_js_1.BigNumber(0),
            totalSpent: tx.amount,
            errors: {},
            warnings: {},
        };
    }
    const { command, fee, errors, warnings } = commandDescriptor;
    const amount = new bignumber_js_1.BigNumber(getAmount(command));
    const estimatedFees = new bignumber_js_1.BigNumber(fee);
    const totalSpent = new bignumber_js_1.BigNumber(getTotalSpent(commandDescriptor));
    return {
        amount,
        estimatedFees,
        totalSpent,
        warnings,
        errors,
    };
});
function getAmount(command) {
    switch (command.kind) {
        case "transfer":
        case "token.transfer":
        case "stake.createAccount":
        case "stake.withdraw":
            return command.amount;
        case "token.createATA":
        case "stake.delegate":
        case "stake.undelegate":
        case "stake.split":
            return 0;
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
}
function getTotalSpent({ command, fee }) {
    switch (command.kind) {
        case "transfer":
        case "stake.createAccount":
            return command.amount < 0 ? 0 : command.amount + fee;
        case "token.transfer":
            return Math.max(command.amount, 0);
        case "token.createATA":
        case "stake.delegate":
        case "stake.undelegate":
        case "stake.withdraw":
        case "stake.split":
            return fee;
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
}
exports.default = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map